import { render, staticRenderFns } from "./SaibaMais.vue?vue&type=template&id=985814ce&scoped=true"
import script from "./SaibaMais.vue?vue&type=script&lang=js"
export * from "./SaibaMais.vue?vue&type=script&lang=js"
import style0 from "./SaibaMais.vue?vue&type=style&index=0&id=985814ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985814ce",
  null
  
)

export default component.exports